<li class="nav-item dropdown no-caret me-3 dropdown-notifications" ngbDropdown [placement]="placement" display="dynamic">
	<a class="btn btn-icon btn-transparent-dark dropdown-toggle position-relative" id="messages" ngbDropdownToggle (click)="messagingService.disabled = true">
		<fa-icon icon="bell"></fa-icon>
		@if (messagingService.total > 0 && !messagingService.disabled) {
			<span
				class="position-absolute translate-middle p-1 bg-danger rounded-circle animate__animated animate__flash animate__slow animate__infinite"
				style="top: 12px; left: 28px"></span>
		}
	</a>

	<div class="dropdown-menu border-0 shadow animated--fade-in-up" style="width: 400px" ngbDropdownMenu aria-labelledby="messages">
		<h6 class="dropdown-header dropdown-notifications-header">Notificações</h6>

		@if (messagingService.messageSource | async) {
			@for (message of messagingService.messages; track message) {
				<sbpro-top-nav-messages-item [message]="message"></sbpro-top-nav-messages-item>
			}
		}

		@if (messagingService.total === 0) {
			<div class="p-2 pt-5 pb-5 text-center">
				<app-empty-data message="Sem notificação" illustrationSize="120"></app-empty-data>
			</div>
		}
	</div>
</li>
